'use strict';
var app = require('angular').module('directive.userUnit', []);

app.directive('userUnit', [require('./userUnitDirective')]);
